// import { useEffect, useRef, useState, useCallback } from "react";
// import emailjs from "emailjs-com";
// import gsap from "gsap";
// import { ScrollTrigger } from "gsap/ScrollTrigger";

// gsap.registerPlugin(ScrollTrigger);

// // ─── Products ────────────────────────────────────────────────────────────────
// const PRODUCTS = [
//   {
//     num: "01", tag: "FLAGSHIP",
//     name: "4 SQ.FT\nHYDROPONICS\nDEVICE",
//     nameSub: "4 sq.ft Hydroponics Device",
//     tagline: "The Personal Food Computer",
//     desc: "An enclosed glass cabinet that transforms any corner into a thriving micro-farm. Multi-tier shelving, full-spectrum LEDs, and a closed-loop system engineered to grow 300 plants.",
//     specs: [{ l:"Capacity", v:"300 Plants"}, {l:"Footprint", v:"4 sq.ft"}, {l:"Energy", v:"0.03 KWh/mo"}, {l:"System", v:"Closed-loop"}],
//     feats: ["Fully automated & water-efficient","IoT real-time monitoring","Full-spectrum LED grow lights","Soil-free cultivation"],
//     image: "/assets/caax/4sqft.jpeg",
//     accent: "#06CCBC", rgb: "6,204,188",
//     bgWords: ["4 SQ.FT", "HYDROPONICS"],
//   },
//   {
//     num: "02", tag: "PRO",
//     name: "PLANTER",
//     nameSub: "Planter",
//     tagline: "Tower Farm, Reinvented",
//     desc: "A sleek 360° glass tower cultivating 75 plants simultaneously. Available in White and Black — fully automated with IoT and mobile app control.",
//     specs: [{l:"Capacity", v:"75 Plants"},{l:"Operation", v:"Fully Auto"},{l:"Control", v:"Mobile App"},{l:"Colors", v:"White & Black"}],
//     feats: ["Fully automated operation","IoT real-time monitoring","Mobile app remote control","360° glass visibility"],
//     image: "/assets/caax/planter.jpeg",
//     accent: "#C084FC", rgb: "192,132,252",
//     bgWords: ["PLANTER", "PRO"],
//   },
//   {
//     num: "03", tag: "STARTER",
//     name: "STEM\nKIT",
//     nameSub: "Stem Kit",
//     tagline: "Learn. Grow. Discover.",
//     desc: "Six slots, zero complexity. Turns hydroponics into a hands-on STEM experience. Safe, intuitive, and genuinely fun for beginners of all ages.",
//     specs: [{l:"Capacity", v:"6 Plants"},{l:"Audience", v:"All Ages"},{l:"Setup", v:"Plug & Grow"},{l:"Purpose", v:"STEM + Home"}],
//     feats: ["Safe beginner-friendly design","Hands-on STEM learning","Homes, schools & classrooms","No prior experience needed"],
//     image: "/assets/caax/stemkit.jpeg",
//     accent: "#34D399", rgb: "52,211,153",
//     bgWords: ["STEM", "KIT"],
//   },
//   {
//     num: "04", tag: "COMPACT",
//     name: "2 SQ.FT\nINDOOR\nDEVICE",
//     nameSub: "2 sq.ft Indoor Device",
//     tagline: "High-Density Open Rack",
//     desc: "Maximum yield in minimum space. Expandable trays for up to 100 plants with built-in grow lights and semi-automated water management.",
//     specs: [{l:"Capacity", v:"100 Plants"},{l:"Lighting", v:"Included"},{l:"Automation", v:"Semi-auto"},{l:"Footprint", v:"2 sq.ft"}],
//     feats: ["100 plants (expandable trays)","Grow lights included","Semi-automated system","Low water, beginner-friendly"],
//     image: "/assets/caax/2sqft.jpeg",
//     accent: "#FB923C", rgb: "251,146,60",
//     bgWords: ["2 SQ.FT", "INDOOR"],
//   },
//   {
//     num: "05", tag: "VERTICAL NFT",
//     name: "WALL\nGARDEN",
//     nameSub: "Wall Garden",
//     tagline: "Living Walls That Feed You",
//     desc: "A vertical nutrient film system that turns any wall into a productive green space. Best for leafy greens and herbs — homes, balconies, greenhouses.",
//     specs: [{l:"System", v:"Vertical NFT"},{l:"Best For", v:"Greens & Herbs"},{l:"Install", v:"Wall-mounted"},{l:"Locations", v:"Home/Balcony"}],
//     feats: ["Vertical nutrient film tech","Water-saving & soil-free","Best for greens & herbs","Homes, balconies, greenhouses"],
//     image: "/assets/caax/wallgarden.jpeg",
//     accent: "#86EFAC", rgb: "134,239,172",
//     bgWords: ["WALL", "GARDEN"],
//   },
//   {
//     num: "06", tag: "OUTDOOR",
//     name: "DWC\nOUTDOOR\nKIT",
//     nameSub: "DWC Outdoor Kit",
//     tagline: "Deep Water Culture, Simplified",
//     desc: "Built for outdoor use with food-grade materials and a simple DWC growing method. 25 plants, minimal maintenance — rugged, reliable, soil-free.",
//     specs: [{l:"Capacity", v:"25 Plants"},{l:"Method", v:"Deep Water"},{l:"Material", v:"Food-grade"},{l:"Use", v:"Outdoor-ready"}],
//     feats: ["Food-grade materials","Simple DWC method","Low maintenance","All-weather outdoor use"],
//     image: "/assets/caax/dwc.jpeg",
//     accent: "#60A5FA", rgb: "96,165,250",
//     bgWords: ["DWC", "OUTDOOR"],
//   },
//   {
//     num: "07", tag: "COMMERCIAL",
//     name: "POLY\nHOUSE",
//     nameSub: "Polyhouse",
//     tagline: "Climate-Controlled Scale",
//     desc: "Starting from 500 sq.ft — a fully climate-controlled environment with durable GI frames, UV-protective covering, customizable for commercial crop production.",
//     specs: [{l:"Size", v:"500+ sq.ft"},{l:"Frame", v:"GI + UV Shield"},{l:"Climate", v:"Controlled"},{l:"Crops", v:"Customizable"}],
//     feats: ["Climate-controlled environment","Durable GI + UV frame","Customizable for any crop","Scalable commercial solution"],
//     image: "/assets/caax/polyhouse.jpeg",
//     accent: "#FCD34D", rgb: "252,211,77",
//     bgWords: ["POLY", "HOUSE"],
//   },
// ];

// const N = PRODUCTS.length;

// // ─── Main ────────────────────────────────────────────────────────────────────
// export default function CaaxPage3D() {
//   const [idx, setIdx]         = useState(0);
//   const [modalOpen, setModal] = useState(false);

//   const wrapRef     = useRef();
//   const imgRef      = useRef();
//   const bgTextRef   = useRef();
//   const leftRef     = useRef();
//   const rightRef    = useRef();
//   const leftMobRef  = useRef();
//   const rightMobRef = useRef();
//   const dotRefs     = useRef([]);
//   const progressRef = useRef();
//   const formRef     = useRef();
//   const floatTL     = useRef();
//   const curIdx      = useRef(0);
//   const busy        = useRef(false);

//   const p = PRODUCTS[idx];

//   const GB = { background:"linear-gradient(88.52deg,#1263AF 29%,#06CCBC 100%)" };
//   const GT = { background:"linear-gradient(88.52deg,#1263AF 29%,#06CCBC 100%)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text" };

//   // ── idle float tween — UNCHANGED
//   const startFloat = useCallback(() => {
//     floatTL.current?.kill();
//     if (!imgRef.current) return;
//     gsap.set(imgRef.current, { y: 0, rotateZ: 0 });
//     floatTL.current = gsap.timeline({ repeat:-1, yoyo:true })
//       .to(imgRef.current, { y:-18, rotateZ: 1.5, duration:3.5, ease:"sine.inOut" })
//       .to(imgRef.current, { y:-6,  rotateZ:-1,   duration:2.8, ease:"sine.inOut" });
//   }, []);

//   // ── transition — UNCHANGED except also animates mobile panels
//   const transitionTo = useCallback((next, dir = 1) => {
//     if (busy.current || next === curIdx.current) return;
//     busy.current = true;
//     floatTL.current?.kill();

//     const img      = imgRef.current;
//     const left     = leftRef.current;
//     const right    = rightRef.current;
//     const leftMob  = leftMobRef.current;
//     const rightMob = rightMobRef.current;
//     const bgTxt    = bgTextRef.current;
//     const D        = 0.5;

//     const tl = gsap.timeline({
//       onComplete: () => {
//         curIdx.current = next;
//         setIdx(next);

//         if (progressRef.current)
//           progressRef.current.style.width = `${((next+1)/N)*100}%`;

//         dotRefs.current.forEach((d,i) => {
//           if (!d) return;
//           d.style.height     = i===next ? "32px" : "10px";
//           d.style.background = i===next ? PRODUCTS[next].accent : "rgba(255,255,255,0.2)";
//         });

//         // enter — image (UNCHANGED)
//         gsap.fromTo(img,
//           { rotateY: dir*-100, rotateX: dir*-15, scale:0.6, y: dir*60, opacity:0, filter:"blur(16px)" },
//           { rotateY:0, rotateX:0, scale:1, y:0, opacity:1, filter:"blur(0px)",
//             duration: D+0.15, ease:"power3.out",
//             onComplete: () => { busy.current=false; startFloat(); }
//           }
//         );
//         // enter — bg text (UNCHANGED)
//         gsap.fromTo(bgTxt,
//           { opacity:0, scale:1.08 },
//           { opacity:1, scale:1, duration:D*0.8, ease:"power2.out" }
//         );
//         // enter — desktop panels (UNCHANGED)
//         if (left)  gsap.fromTo(left,  { x: dir*-80, opacity:0 }, { x:0, opacity:1, duration:D, ease:"power3.out", delay:0.06 });
//         if (right) gsap.fromTo(right, { x: dir*80,  opacity:0 }, { x:0, opacity:1, duration:D, ease:"power3.out", delay:0.06 });
//         // enter — mobile panels (NEW)
//         if (leftMob)  gsap.fromTo(leftMob,  { y:-20, opacity:0 }, { y:0, opacity:1, duration:D*0.9, ease:"power3.out", delay:0.06 });
//         if (rightMob) gsap.fromTo(rightMob, { y: 20, opacity:0 }, { y:0, opacity:1, duration:D*0.9, ease:"power3.out", delay:0.06 });
//       }
//     });

//     // exit — image (UNCHANGED)
//     tl.to(img, {
//       rotateY: dir*100, rotateX: dir*12,
//       scale:0.55, y: dir*-60,
//       opacity:0, filter:"blur(16px)",
//       duration:D, ease:"power2.in"
//     }, 0)
//     // exit — bg text (UNCHANGED)
//     .to(bgTxt, { opacity:0, scale:0.94, duration:D*0.6, ease:"power2.in" }, 0)
//     // exit — desktop panels (UNCHANGED)
//     .to(left  || {}, { x: dir*80,  opacity:0, duration:D*0.7, ease:"power2.in" }, 0)
//     .to(right || {}, { x: dir*-80, opacity:0, duration:D*0.7, ease:"power2.in" }, 0)
//     // exit — mobile panels (NEW)
//     .to(leftMob  || {}, { y:-16, opacity:0, duration:D*0.6, ease:"power2.in" }, 0)
//     .to(rightMob || {}, { y: 16, opacity:0, duration:D*0.6, ease:"power2.in" }, 0);
//   }, [startFloat]);

//   // ── ScrollTrigger — UNCHANGED
//   useEffect(() => {
//     if (progressRef.current)
//       progressRef.current.style.width = `${(1/N)*100}%`;

//     const ctx = gsap.context(() => {
//       ScrollTrigger.create({
//         trigger: wrapRef.current,
//         start: "top top",
//         end: "bottom bottom",
//         onUpdate: (self) => {
//           const next = Math.round(self.progress * (N-1));
//           const dir  = next > curIdx.current ? 1 : -1;
//           if (next !== curIdx.current) transitionTo(next, dir);
//         }
//       });
//     }, wrapRef);

//     startFloat();
//     return () => ctx.revert();
//   }, [transitionTo, startFloat]);

//   // ── keyboard — UNCHANGED
//   useEffect(() => {
//     const h = (e) => {
//       if (e.key==="ArrowDown"||e.key==="ArrowRight") {
//         const next = Math.min(N-1, curIdx.current+1);
//         transitionTo(next, 1);
//         scrollToIdx(next);
//       }
//       if (e.key==="ArrowUp"||e.key==="ArrowLeft") {
//         const next = Math.max(0, curIdx.current-1);
//         transitionTo(next, -1);
//         scrollToIdx(next);
//       }
//     };
//     window.addEventListener("keydown", h);
//     return () => window.removeEventListener("keydown", h);
//   }, [transitionTo]);

//   const scrollToIdx = (i) => {
//     if (!wrapRef.current) return;
//     const pct    = i/(N-1);
//     const totalH = wrapRef.current.scrollHeight - window.innerHeight;
//     window.scrollTo({ top: wrapRef.current.offsetTop + pct*totalH, behavior:"smooth" });
//   };

//   const goTo = useCallback((i) => {
//     const dir = i > curIdx.current ? 1 : -1;
//     transitionTo(i, dir);
//     scrollToIdx(i);
//   }, [transitionTo]); // eslint-disable-line

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     emailjs.sendForm(
//       process.env.REACT_APP_EMAILJS_SERVICE_ID,
//       process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
//       formRef.current,
//       process.env.REACT_APP_EMAILJS_PUBLIC_KEY
//     ).then(()=>{ alert("Sent!"); setModal(false); }, ()=>alert("Failed. Try again."));
//   };

//   return (
//     <div style={{ fontFamily:"'Syne',sans-serif" }}>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@900&family=Syne:wght@400;600;700;800&display=swap');

//         /* ── UNCHANGED: image 3D + blend ── */
//         #caax-img {
//           transform-style: preserve-3d;
//           will-change: transform, opacity, filter;
//           mix-blend-mode: normal;
//           filter: drop-shadow(0 50px 80px rgba(0,0,0,0.8)) drop-shadow(0 0 40px rgba(6,204,188,0.3)) brightness(1.02);
//           transition: filter 0.7s ease;
//         }

//         /* ── UNCHANGED: giant bg text ── */
//         #caax-bg-text {
//           position: absolute;
//           inset: 0;
//           display: flex;
//           flex-direction: column;
//           align-items: center;
//           justify-content: center;
//           pointer-events: none;
//           user-select: none;
//         }
//         .caax-bg-word {
//           font-family: 'Syne', sans-serif;
//           font-weight: 800;
//           line-height: 0.88;
//           letter-spacing: -0.03em;
//           white-space: nowrap;
//         }

//         /* ── UNCHANGED ── */
//         #caax-prog { transition: width .5s ease, background .8s ease; }
//         .caax-dot  { border-radius:2px; transition: height .4s ease, background .4s ease; display:block; cursor:pointer; }

//         @keyframes mq  { from{transform:translateX(0)} to{transform:translateX(-50%)} }
//         @keyframes hu  { from{opacity:0;transform:translateY(28px)} to{opacity:1;transform:translateY(0)} }
//         @keyframes mIn { from{opacity:0;transform:scale(.95) translateY(12px)} to{opacity:1;transform:scale(1) translateY(0)} }
//         @keyframes spin{ from{transform:rotate(0deg)} to{transform:rotate(360deg)} }

//         .mq   { display:flex; width:max-content; animation:mq 32s linear infinite; }
//         .hu1  { animation:hu .9s cubic-bezier(.22,1,.36,1) both  .1s;  opacity:0; }
//         .hu2  { animation:hu .9s cubic-bezier(.22,1,.36,1) both  .25s; opacity:0; }
//         .hu3  { animation:hu .9s cubic-bezier(.22,1,.36,1) both  .4s;  opacity:0; }
//         .hu4  { animation:hu .9s cubic-bezier(.22,1,.36,1) both  .55s; opacity:0; }
//         .m-in { animation:mIn .35s cubic-bezier(.22,1,.36,1) both; }

//         /* ── UNCHANGED desktop panels ── */
//         #caax-left, #caax-right { will-change: transform, opacity; }

//         /* ── NEW: mobile panels also need will-change for GSAP ── */
//         #caax-left-m, #caax-right-m { will-change: transform, opacity; }
//       `}</style>

//       {/* ── HERO — only padding adjusted for mobile, content UNCHANGED ── */}
//       <section className="relative w-full flex flex-col items-center justify-center text-center px-6 py-20 md:py-36">
//         <p className="hu1 text-xs font-bold tracking-[.35em] uppercase mb-5" style={{color:"#06CCBC"}}>
//           CAAX
//         </p>
//         <h1 className="hu2 font-black text-white leading-none mb-6"
//           style={{fontSize:"clamp(2.6rem,9vw,8rem)",fontFamily:"'Playfair Display',serif",letterSpacing:"-.04em"}}>
//           Grow Smarter.<br /><span style={GT}>Live Greener.</span>
//         </h1>
//         <p className="hu3 text-gray-400 max-w-md mx-auto text-base md:text-lg leading-relaxed mb-10">
//           Seven precision-engineered hydroponics products. Scroll to explore each one.
//         </p>
//         <div className="hu4 flex flex-wrap justify-center gap-2 md:gap-3">
//           {[["90%","Less Water"],["300+","Plants"],["7","Products"],["IoT","Connected"]].map(([n,l],i)=>(
//             <div key={i} className="flex items-baseline gap-2 px-4 py-2 md:px-5 md:py-2.5 rounded-full"
//               style={{border:"1px solid rgba(255,255,255,.08)"}}>
//               <span className="text-lg md:text-xl font-black" style={GT}>{n}</span>
//               <span className="text-xs text-gray-500">{l}</span>
//             </div>
//           ))}
//         </div>
//       </section>

//       {/* ── MARQUEE — UNCHANGED ── */}
//       <div className="overflow-hidden border-y py-3.5" style={{borderColor:"rgba(255,255,255,.05)"}}>
//         <div className="mq">
//           {[...Array(2)].map((_,o)=>
//             ["4 sq.ft Device","Planter","Stem Kit","2 sq.ft Indoor","Wall Garden","DWC Outdoor Kit","Polyhouse","IoT Farming","Soil-Free","Sustainable"].map((w,i)=>(
//               <span key={`${o}-${i}`} className="text-xs font-bold tracking-[.3em] uppercase mx-8"
//                 style={{color:i%4===0?"#06CCBC":"rgba(255,255,255,.07)"}}>
//                 {w} ·
//               </span>
//             ))
//           )}
//         </div>
//       </div>

//       {/* ── SCROLL WRAPPER — UNCHANGED ── */}
//       <div ref={wrapRef} style={{height:`${N*100}vh`, position:"relative"}}>

//         {/* STICKY PANEL — UNCHANGED */}
//         <div style={{position:"sticky", top:0, height:"100vh", overflow:"hidden"}}>

//           {/* Ambient glow — UNCHANGED */}
//           <div className="absolute inset-0 pointer-events-none transition-all duration-1000"
//             style={{background:`radial-gradient(ellipse 70% 80% at 50% 50%, rgba(${p.rgb},.07) 0%, transparent 65%)`}} />

//           {/* Top progress — UNCHANGED */}
//           <div className="absolute top-0 left-0 right-0 z-30" style={{height:"2px",background:"rgba(255,255,255,.04)"}}>
//             <div id="caax-prog" ref={progressRef}
//               style={{height:"100%",width:`${(1/N)*100}%`,background:`linear-gradient(90deg,rgba(${p.rgb},.9),rgba(${p.rgb},.3))`}} />
//           </div>

//           {/* Giant bg text — UNCHANGED */}
//           <div id="caax-bg-text" ref={bgTextRef}>
//             {p.bgWords.map((word, wi) => (
//               <div key={wi} className="caax-bg-word transition-colors duration-700"
//                 style={{
//                   fontSize: "clamp(4rem, 14vw, 13rem)",
//                   color: `rgba(${p.rgb}, ${wi===0 ? 0.18 : 0.11})`,
//                 }}>
//                 {word}
//               </div>
//             ))}
//           </div>

//           {/* ── SHARED FLOATING IMAGE ── sits in absolute center, visible on ALL screens,
//                GSAP animates this one element — zero duplication, works desktop + mobile ── */}
//           <div className="absolute inset-0 z-10 flex items-center justify-center pointer-events-none"
//             style={{perspective:"1000px", perspectiveOrigin:"50% 50%"}}>
//             <div className="flex flex-col items-center">
//               <img
//                 id="caax-img"
//                 ref={imgRef}
//                 src={p.image}
//                 alt={p.nameSub}
//                 draggable={false}
//                 style={{
//                   /* Desktop: uses vw sizing; mobile: uses smaller vw via clamp */
//                   width: "clamp(160px, 24vw, 420px)",
//                   height: "auto",
//                   display: "block",
//                   mixBlendMode: "normal",
//                   filter: `drop-shadow(0 50px 80px rgba(0,0,0,0.8)) drop-shadow(0 0 40px rgba(${p.rgb},0.3)) brightness(1.02)`,
//                   transform: "perspective(1000px) rotateY(0deg) rotateX(0deg)",
//                   transition: "filter 0.7s ease",
//                   pointerEvents: "none",
//                 }}
//               />
//               {/* Glow puddle */}
//               <div className="rounded-full blur-3xl -mt-8 pointer-events-none transition-all duration-700"
//                 style={{width:"55%", height:"30px", background:`rgba(${p.rgb},.25)`}} />
//             </div>
//           </div>

//           {/* ── DESKTOP 3-col layout — UNCHANGED ── */}
//           <div className="hidden lg:flex relative z-10 h-full items-center justify-center px-4 md:px-12">
//             <div className="w-full max-w-screen-xl grid items-center"
//               style={{gridTemplateColumns:"1fr auto 1fr", gap:"clamp(1rem,4vw,5rem)"}}>

//               {/* LEFT — UNCHANGED */}
//               <div id="caax-left" ref={leftRef} className="flex flex-col space-y-5">
//                 <div className="flex items-end gap-3 select-none">
//                   <span className="font-black leading-none transition-colors duration-700"
//                     style={{fontSize:"6.5rem",color:`rgba(${p.rgb},.12)`,fontFamily:"'Playfair Display',serif",lineHeight:1}}>
//                     {p.num}
//                   </span>
//                   <div className="mb-2">
//                     <span className="block text-xs font-black tracking-[.28em] uppercase transition-colors duration-500"
//                       style={{color:p.accent}}>{p.tag}</span>
//                     <div className="mt-1.5 h-0.5 w-8 rounded-full transition-all duration-500"
//                       style={{background:p.accent}} />
//                   </div>
//                 </div>
//                 <h2 className="font-black text-white leading-none"
//                   style={{fontSize:"clamp(1.8rem,2.8vw,2.8rem)",fontFamily:"'Playfair Display',serif",letterSpacing:"-.03em"}}>
//                   {p.nameSub}
//                 </h2>
//                 <p className="text-xs font-bold tracking-[.22em] uppercase transition-colors duration-500"
//                   style={{color:p.accent}}>{p.tagline}</p>
//                 <p className="text-gray-400 text-sm leading-relaxed" style={{maxWidth:"290px"}}>{p.desc}</p>
//                 <button onClick={()=>setModal(true)}
//                   className="self-start px-7 py-3 rounded-full text-sm font-black tracking-wide transition-all hover:scale-105 hover:brightness-110 pointer-events-auto"
//                   style={{background:p.accent,color:"#000",boxShadow:`0 0 28px rgba(${p.rgb},.45)`,transition:"background .5s,box-shadow .5s"}}>
//                   Inquire Now →
//                 </button>
//               </div>

//               {/* CENTER spacer — image is absolutely positioned above */}
//               <div style={{width:"clamp(240px,28vw,420px)"}} />

//               {/* RIGHT — UNCHANGED */}
//               <div id="caax-right" ref={rightRef} className="flex flex-col space-y-6">
//                 <div>
//                   <p className="text-xs font-black tracking-[.28em] uppercase text-gray-600 mb-3">Specifications</p>
//                   <div className="grid grid-cols-2 gap-2">
//                     {p.specs.map((s,i)=>(
//                       <div key={i} className="p-3.5 rounded-2xl transition-all duration-700"
//                         style={{border:`1px solid rgba(${p.rgb},.18)`,background:`rgba(${p.rgb},.06)`}}>
//                         <div className="text-xs text-gray-600 mb-1 tracking-wide uppercase">{s.l}</div>
//                         <div className="font-black text-sm transition-colors duration-500" style={{color:p.accent}}>{s.v}</div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//                 <div>
//                   <p className="text-xs font-black tracking-[.28em] uppercase text-gray-600 mb-3">Features</p>
//                   <div className="space-y-2.5">
//                     {p.feats.map((f,i)=>(
//                       <div key={i} className="flex items-center gap-3">
//                         <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-500"
//                           style={{background:`rgba(${p.rgb},.14)`,border:`1px solid rgba(${p.rgb},.4)`}}>
//                           <svg width="9" height="7" viewBox="0 0 9 7" fill="none">
//                             <path d="M1 3.5L3.2 5.5L8 1" stroke={p.accent} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
//                           </svg>
//                         </div>
//                         <span className="text-gray-300 text-sm">{f}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//                 <div className="h-px transition-all duration-700"
//                   style={{background:`linear-gradient(90deg,rgba(${p.rgb},.5),transparent)`}} />
//                 <div className="font-black text-right select-none leading-none"
//                   style={{fontSize:"4.5rem",color:`rgba(${p.rgb},.07)`,fontFamily:"'Playfair Display',serif",transition:"color .5s"}}>
//                   {p.num}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* ── MOBILE layout — vertical stack, image shown via absolute layer above ── */}
//           <div className="lg:hidden relative z-10 h-full flex flex-col justify-between py-12 px-5">

//             {/* TOP: tag pill + product name + tagline */}
//             <div id="caax-left-m" ref={leftMobRef} className="text-center space-y-1">
//               <div className="flex items-center justify-center gap-2 mb-1">
//                 <div className="h-px w-5 flex-shrink-0" style={{background:p.accent}} />
//                 <span className="text-xs font-black tracking-[.25em] uppercase transition-colors duration-500"
//                   style={{color:p.accent}}>{p.tag}</span>
//                 <div className="h-px w-5 flex-shrink-0" style={{background:p.accent}} />
//               </div>
//               <h2 className="font-black text-white leading-tight"
//                 style={{fontSize:"clamp(1.5rem,6.5vw,2.2rem)",fontFamily:"'Playfair Display',serif",letterSpacing:"-.03em"}}>
//                 {p.nameSub}
//               </h2>
//               <p className="text-xs font-bold tracking-[.18em] uppercase"
//                 style={{color:p.accent, opacity:.7}}>{p.tagline}</p>
//             </div>

//             {/* SPACER — the image floats here via the absolute layer */}
//             <div className="flex-1" />

//             {/* BOTTOM: specs 2×2 grid + CTA */}
//             <div id="caax-right-m" ref={rightMobRef} className="space-y-3">
//               <div className="grid grid-cols-2 gap-2">
//                 {p.specs.map((s,i)=>(
//                   <div key={i} className="p-3 rounded-xl transition-all duration-700"
//                     style={{border:`1px solid rgba(${p.rgb},.18)`,background:`rgba(${p.rgb},.06)`}}>
//                     <div className="text-gray-500 mb-0.5 tracking-wide uppercase"
//                       style={{fontSize:"9px"}}>{s.l}</div>
//                     <div className="font-black text-xs transition-colors duration-500"
//                       style={{color:p.accent}}>{s.v}</div>
//                   </div>
//                 ))}
//               </div>
//               <button onClick={()=>setModal(true)}
//                 className="w-full py-3.5 rounded-full text-sm font-black tracking-wide transition-all active:scale-95 pointer-events-auto"
//                 style={{background:p.accent,color:"#000",boxShadow:`0 0 20px rgba(${p.rgb},.4)`,transition:"background .5s,box-shadow .5s"}}>
//                 Inquire Now →
//               </button>
//             </div>

//           </div>
//           {/* END MOBILE LAYOUT */}

//           {/* ── Dot nav — desktop only ── */}
//           <div className="hidden lg:flex absolute left-4 md:left-7 top-1/2 -translate-y-1/2 z-20 flex-col gap-2.5">
//             {PRODUCTS.map((pr,i)=>(
//               <button key={i}
//                 ref={el=>dotRefs.current[i]=el}
//                 className="caax-dot"
//                 onClick={()=>goTo(i)}
//                 title={pr.nameSub}
//                 style={{
//                   width:"3px",
//                   height: i===0 ? "32px":"10px",
//                   background: i===0 ? PRODUCTS[0].accent : "rgba(255,255,255,.2)",
//                 }} />
//             ))}
//           </div>

//           {/* ── Counter — desktop only ── */}
//           <div className="hidden lg:block absolute bottom-6 right-6 z-20">
//             <span className="text-sm font-black transition-colors duration-500" style={{color:p.accent}}>{p.num}</span>
//             <span className="text-sm font-bold text-gray-700"> / {String(N).padStart(2,"0")}</span>
//           </div>

//           {/* ── Arrows — both mobile & desktop, counter shown inline on mobile ── */}
//           <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 flex items-center gap-3">
//             <button onClick={()=>goTo(Math.max(0,idx-1))} disabled={idx===0}
//               className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110 active:scale-95"
//               style={{border:`1px solid rgba(${p.rgb},${idx===0 ? .1 : .4})`,color:idx===0?"rgba(255,255,255,.15)":p.accent}}>
//               <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M15 18l-6-6 6-6"/></svg>
//             </button>
//             {/* counter visible on mobile between arrows */}
//             <span className="text-xs font-black lg:hidden" style={{color:p.accent}}>
//               {p.num}<span className="text-gray-700 font-bold"> / {String(N).padStart(2,"0")}</span>
//             </span>
//             {/* scroll hint on desktop first product */}
//             {idx===0 && <span className="text-xs text-gray-600 tracking-widest uppercase animate-bounce select-none hidden lg:inline">scroll ↓</span>}
//             <button onClick={()=>goTo(Math.min(N-1,idx+1))} disabled={idx===N-1}
//               className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110 active:scale-95"
//               style={{border:`1px solid rgba(${p.rgb},${idx===N-1 ? .1 : .4})`,color:idx===N-1?"rgba(255,255,255,.15)":p.accent}}>
//               <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M9 18l6-6-6-6"/></svg>
//             </button>
//           </div>

//           {/* ── Tagline watermark — desktop only, UNCHANGED ── */}
//           <div className="absolute bottom-16 left-1/2 -translate-x-1/2 z-10 text-center pointer-events-none select-none hidden lg:block">
//             <p className="text-xs font-bold tracking-[.3em] uppercase transition-colors duration-500"
//               style={{color:`rgba(${p.rgb},.35)`}}>
//               {p.tagline}
//             </p>
//           </div>

//         </div>
//         {/* /sticky */}
//       </div>
//       {/* /scroll wrapper */}

//       {/* ── WHY CAAX — UNCHANGED ── */}
//       <section className="w-full max-w-6xl mx-auto px-6 py-24">
//         <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
//           <div>
//             <p className="text-xs font-black tracking-[.3em] uppercase mb-4" style={{color:"#06CCBC"}}>Why CAAX</p>
//             <h2 className="font-black text-white leading-none mb-6"
//               style={{fontSize:"clamp(2.2rem,5vw,4rem)",fontFamily:"'Playfair Display',serif",letterSpacing:"-.03em"}}>
//               Grown with <span style={GT}>Science,</span><br />Not Soil.
//             </h2>
//             <p className="text-gray-400 leading-relaxed mb-8 text-sm max-w-md">
//               Every CAAX product is built around one principle — do more with less.
//               Less water, less energy, less space. More food, more control, more freedom.
//             </p>
//           </div>
//           <div className="space-y-1">
//             {[
//               {n:"90%", t:"Less Water",    d:"Closed-loop hydroponic systems with near-zero water waste."},
//               {n:"0.03",t:"KWh / Month",   d:"Grow fresh greens for less power than a phone charger."},
//               {n:"IoT", t:"Connected",     d:"Real-time monitoring, automated nutrients, mobile app."},
//               {n:"7×",  t:"Product Range", d:"From 6-plant Stem Kits to 500+ sq.ft Polyhouses."},
//             ].map((item,i)=>(
//               <div key={i} className="flex items-start gap-6 p-5 rounded-2xl cursor-default transition-all hover:bg-white/[.03]"
//                 style={{borderBottom:i<3?"1px solid rgba(255,255,255,.05)":"none"}}>
//                 <div className="font-black flex-shrink-0 w-14 text-right text-2xl"
//                   style={{fontFamily:"'Playfair Display',serif",...GT}}>{item.n}</div>
//                 <div>
//                   <div className="font-bold text-white mb-1 text-sm">{item.t}</div>
//                   <div className="text-gray-500 text-sm leading-relaxed">{item.d}</div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ── CTA — UNCHANGED ── */}
//       <section className="w-full max-w-6xl mx-auto px-6 pb-24">
//         <div className="relative overflow-hidden rounded-3xl p-10 md:p-16 text-center"
//           style={{border:"1px solid rgba(255,255,255,.06)"}}>
//           <div className="absolute -top-20 -right-20 w-56 h-56 rounded-full pointer-events-none"
//             style={{border:"1px solid rgba(6,204,188,.07)",animation:"spin 25s linear infinite"}} />
//           <div className="absolute -bottom-12 -left-12 w-40 h-40 rounded-full pointer-events-none"
//             style={{border:"1px solid rgba(18,99,175,.07)",animation:"spin 18s linear infinite reverse"}} />
//           <div className="relative z-10">
//             <p className="text-xs font-black tracking-[.3em] uppercase mb-4" style={{color:"#06CCBC"}}>Start Growing Today</p>
//             <h2 className="font-black text-white leading-none mb-6"
//               style={{fontSize:"clamp(2rem,5vw,4rem)",fontFamily:"'Playfair Display',serif",letterSpacing:"-.03em"}}>
//               Your farm. Your food.<br /><span style={GT}>Your CAAX.</span>
//             </h2>
//             <p className="text-gray-400 max-w-lg mx-auto mb-8 leading-relaxed text-sm">
//               From first-time growers to commercial producers — there's a CAAX product built exactly for you.
//             </p>
//             <button onClick={()=>setModal(true)}
//               className="px-10 md:px-12 py-4 md:py-5 rounded-full text-white font-bold text-base transition-all hover:scale-105"
//               style={{...GB,boxShadow:"0 8px 40px rgba(18,99,175,.4)"}}>
//               Connect With Us →
//             </button>
//           </div>
//         </div>
//       </section>

//       {/* ── MODAL — UNCHANGED ── */}
//       {modalOpen && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-xl">
//           <div className="m-in w-full max-w-md rounded-3xl overflow-hidden shadow-2xl"
//             style={{border:"1px solid rgba(255,255,255,.08)",background:"rgba(6,10,20,.98)"}}>
//             <div className="px-6 md:px-8 pt-7 md:pt-8 pb-5 border-b" style={{borderColor:"rgba(255,255,255,.06)"}}>
//               <div className="flex items-start justify-between">
//                 <div>
//                   <div className="text-xs font-black tracking-[.25em] uppercase mb-2" style={{color:"#06CCBC"}}>Get in Touch</div>
//                   <h2 className="font-black text-white"
//                     style={{fontSize:"1.5rem",fontFamily:"'Playfair Display',serif",letterSpacing:"-.03em"}}>Connect With Us</h2>
//                 </div>
//                 <button onClick={()=>setModal(false)}
//                   className="w-9 h-9 rounded-full flex items-center justify-center text-gray-500 hover:text-white transition-colors mt-1"
//                   style={{border:"1px solid rgba(255,255,255,.1)"}}>
//                   <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
//                   </svg>
//                 </button>
//               </div>
//             </div>
//             <div className="px-6 md:px-8 py-5 md:py-6">
//               <form ref={formRef} onSubmit={handleSubmit} className="space-y-4">
//                 {[
//                   {label:"Name",  name:"name",   type:"text",  ph:"Your full name"},
//                   {label:"Phone", name:"number", type:"text",  ph:"Your phone number"},
//                   {label:"Email", name:"email",  type:"email", ph:"your@email.com"},
//                 ].map(field=>(
//                   <div key={field.name}>
//                     <label className="block text-xs font-bold tracking-widest uppercase text-gray-600 mb-2">{field.label}</label>
//                     <input type={field.type} name={field.name} placeholder={field.ph} required
//                       className="w-full px-4 py-3 rounded-xl text-white placeholder-gray-700 text-sm focus:outline-none"
//                       style={{background:"rgba(255,255,255,.04)",border:"1px solid rgba(255,255,255,.08)"}} />
//                   </div>
//                 ))}
//                 <div>
//                   <label className="block text-xs font-bold tracking-widest uppercase text-gray-600 mb-2">Message</label>
//                   <textarea name="message" required placeholder="Which CAAX product interests you?"
//                     className="w-full px-4 py-3 rounded-xl text-white placeholder-gray-700 text-sm focus:outline-none resize-none"
//                     style={{background:"rgba(255,255,255,.04)",border:"1px solid rgba(255,255,255,.08)",minHeight:"85px"}} />
//                 </div>
//                 <div className="flex gap-3 pt-1">
//                   <button type="button" onClick={()=>setModal(false)}
//                     className="flex-1 py-3 rounded-xl text-sm font-semibold text-gray-500 hover:text-gray-300 transition-colors"
//                     style={{border:"1px solid rgba(255,255,255,.08)"}}>Cancel</button>
//                   <button type="submit"
//                     className="flex-1 py-3 rounded-xl text-white font-bold text-sm hover:opacity-90 transition-opacity"
//                     style={GB}>Send Message</button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import { useEffect, useRef, useState, useCallback } from "react";
import emailjs from "emailjs-com";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// ─── Products ────────────────────────────────────────────────────────────────
const PRODUCTS = [
  {
    num: "01", tag: "FLAGSHIP",
    name: "4 SQ.FT\nHYDROPONICS\nDEVICE",
    nameSub: "4 sq.ft Hydroponics Device",
    tagline: "The Personal Food Computer",
    desc: "An enclosed glass cabinet that transforms any corner into a thriving micro-farm. Multi-tier shelving, full-spectrum LEDs, and a closed-loop system engineered to grow 300 plants.",
    specs: [{ l:"Capacity", v:"300 Plants"}, {l:"Footprint", v:"4 sq.ft"}, {l:"Energy", v:"0.03 KWh/mo"}, {l:"System", v:"Closed-loop"}],
    feats: ["Fully automated & water-efficient","IoT real-time monitoring","Full-spectrum LED grow lights","Soil-free cultivation"],
    image: "/assets/caax/4sqft.jpeg",
    accent: "#06CCBC", rgb: "6,204,188",
    bgWords: ["4 SQ.FT", "HYDROPONICS"],
  },
  {
    num: "02", tag: "PRO",
    name: "PLANTER",
    nameSub: "Planter",
    tagline: "Tower Farm, Reinvented",
    desc: "A sleek 360° glass tower cultivating 75 plants simultaneously. Available in White and Black — fully automated with IoT and mobile app control.",
    specs: [{l:"Capacity", v:"75 Plants"},{l:"Operation", v:"Fully Auto"},{l:"Control", v:"Mobile App"},{l:"Colors", v:"White & Black"}],
    feats: ["Fully automated operation","IoT real-time monitoring","Mobile app remote control","360° glass visibility"],
    image: "/assets/caax/planter.jpeg",
    accent: "#C084FC", rgb: "192,132,252",
    bgWords: ["PLANTER", "PRO"],
  },
  {
    num: "03", tag: "STARTER",
    name: "STEM\nKIT",
    nameSub: "Stem Kit",
    tagline: "Learn. Grow. Discover.",
    desc: "Six slots, zero complexity. Turns hydroponics into a hands-on STEM experience. Safe, intuitive, and genuinely fun for beginners of all ages.",
    specs: [{l:"Capacity", v:"6 Plants"},{l:"Audience", v:"All Ages"},{l:"Setup", v:"Plug & Grow"},{l:"Purpose", v:"STEM + Home"}],
    feats: ["Safe beginner-friendly design","Hands-on STEM learning","Homes, schools & classrooms","No prior experience needed"],
    image: "/assets/caax/stemkit.jpeg",
    accent: "#34D399", rgb: "52,211,153",
    bgWords: ["STEM", "KIT"],
  },
  {
    num: "04", tag: "COMPACT",
    name: "2 SQ.FT\nINDOOR\nDEVICE",
    nameSub: "2 sq.ft Indoor Device",
    tagline: "High-Density Open Rack",
    desc: "Maximum yield in minimum space. Expandable trays for up to 100 plants with built-in grow lights and semi-automated water management.",
    specs: [{l:"Capacity", v:"100 Plants"},{l:"Lighting", v:"Included"},{l:"Automation", v:"Semi-auto"},{l:"Footprint", v:"2 sq.ft"}],
    feats: ["100 plants (expandable trays)","Grow lights included","Semi-automated system","Low water, beginner-friendly"],
    image: "/assets/caax/2sqft.jpeg",
    accent: "#FB923C", rgb: "251,146,60",
    bgWords: ["2 SQ.FT", "INDOOR"],
  },
  {
    num: "05", tag: "VERTICAL NFT",
    name: "WALL\nGARDEN",
    nameSub: "Wall Garden",
    tagline: "Living Walls That Feed You",
    desc: "A vertical nutrient film system that turns any wall into a productive green space. Best for leafy greens and herbs — homes, balconies, greenhouses.",
    specs: [{l:"System", v:"Vertical NFT"},{l:"Best For", v:"Greens & Herbs"},{l:"Install", v:"Wall-mounted"},{l:"Locations", v:"Home/Balcony"}],
    feats: ["Vertical nutrient film tech","Water-saving & soil-free","Best for greens & herbs","Homes, balconies, greenhouses"],
    image: "/assets/caax/wallgarden.jpeg",
    accent: "#86EFAC", rgb: "134,239,172",
    bgWords: ["WALL", "GARDEN"],
  },
  {
    num: "06", tag: "OUTDOOR",
    name: "DWC\nOUTDOOR\nKIT",
    nameSub: "DWC Outdoor Kit",
    tagline: "Deep Water Culture, Simplified",
    desc: "Built for outdoor use with food-grade materials and a simple DWC growing method. 25 plants, minimal maintenance — rugged, reliable, soil-free.",
    specs: [{l:"Capacity", v:"25 Plants"},{l:"Method", v:"Deep Water"},{l:"Material", v:"Food-grade"},{l:"Use", v:"Outdoor-ready"}],
    feats: ["Food-grade materials","Simple DWC method","Low maintenance","All-weather outdoor use"],
    image: "/assets/caax/dwc.jpeg",
    accent: "#60A5FA", rgb: "96,165,250",
    bgWords: ["DWC", "OUTDOOR"],
  },
  {
    num: "07", tag: "COMMERCIAL",
    name: "POLY\nHOUSE",
    nameSub: "Polyhouse",
    tagline: "Climate-Controlled Scale",
    desc: "Starting from 500 sq.ft — a fully climate-controlled environment with durable GI frames, UV-protective covering, customizable for commercial crop production.",
    specs: [{l:"Size", v:"500+ sq.ft"},{l:"Frame", v:"GI + UV Shield"},{l:"Climate", v:"Controlled"},{l:"Crops", v:"Customizable"}],
    feats: ["Climate-controlled environment","Durable GI + UV frame","Customizable for any crop","Scalable commercial solution"],
    image: "/assets/caax/polyhouse.jpeg",
    accent: "#FCD34D", rgb: "252,211,77",
    bgWords: ["POLY", "HOUSE"],
  },
];

const N = PRODUCTS.length;

// ─── Main ────────────────────────────────────────────────────────────────────
export default function CaaxPage3D() {
  const [idx, setIdx]         = useState(0);
  const [modalOpen, setModal] = useState(false);

  const wrapRef     = useRef();
  const imgRef      = useRef();
  const bgTextRef   = useRef();
  const leftRef     = useRef();
  const rightRef    = useRef();
  // ── NEW: separate refs for mobile panels so GSAP can animate them too
  const leftMobRef  = useRef();
  const rightMobRef = useRef();
  const dotRefs     = useRef([]);
  const progressRef = useRef();
  const formRef     = useRef();
  const floatTL     = useRef();
  const curIdx      = useRef(0);
  const busy        = useRef(false);

  const p = PRODUCTS[idx];

  const GB = { background:"linear-gradient(88.52deg,#1263AF 29%,#06CCBC 100%)" };
  const GT = { background:"linear-gradient(88.52deg,#1263AF 29%,#06CCBC 100%)", WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent", backgroundClip:"text" };

  // ── idle float tween — UNCHANGED
  const startFloat = useCallback(() => {
    floatTL.current?.kill();
    if (!imgRef.current) return;
    gsap.set(imgRef.current, { y: 0, rotateZ: 0 });
    floatTL.current = gsap.timeline({ repeat:-1, yoyo:true })
      .to(imgRef.current, { y:-18, rotateZ: 1.5, duration:3.5, ease:"sine.inOut" })
      .to(imgRef.current, { y:-6,  rotateZ:-1,   duration:2.8, ease:"sine.inOut" });
  }, []);

  // ── transition — UNCHANGED except also animates mobile panels
  const transitionTo = useCallback((next, dir = 1) => {
    if (busy.current || next === curIdx.current) return;
    busy.current = true;
    floatTL.current?.kill();

    const img      = imgRef.current;
    const left     = leftRef.current;
    const right    = rightRef.current;
    const leftMob  = leftMobRef.current;
    const rightMob = rightMobRef.current;
    const bgTxt    = bgTextRef.current;
    const D        = 0.5;

    const tl = gsap.timeline({
      onComplete: () => {
        curIdx.current = next;
        setIdx(next);

        if (progressRef.current)
          progressRef.current.style.width = `${((next+1)/N)*100}%`;

        dotRefs.current.forEach((d,i) => {
          if (!d) return;
          d.style.height     = i===next ? "32px" : "10px";
          d.style.background = i===next ? PRODUCTS[next].accent : "rgba(255,255,255,0.2)";
        });

        // enter — image (UNCHANGED)
        gsap.fromTo(img,
          { rotateY: dir*-100, rotateX: dir*-15, scale:0.6, y: dir*60, opacity:0, filter:"blur(16px)" },
          { rotateY:0, rotateX:0, scale:1, y:0, opacity:1, filter:"blur(0px)",
            duration: D+0.15, ease:"power3.out",
            onComplete: () => { busy.current=false; startFloat(); }
          }
        );
        // enter — bg text (UNCHANGED)
        gsap.fromTo(bgTxt,
          { opacity:0, scale:1.08 },
          { opacity:1, scale:1, duration:D*0.8, ease:"power2.out" }
        );
        // enter — desktop panels (UNCHANGED)
        if (left)  gsap.fromTo(left,  { x: dir*-80, opacity:0 }, { x:0, opacity:1, duration:D, ease:"power3.out", delay:0.06 });
        if (right) gsap.fromTo(right, { x: dir*80,  opacity:0 }, { x:0, opacity:1, duration:D, ease:"power3.out", delay:0.06 });
        // enter — mobile panels (NEW)
        if (leftMob)  gsap.fromTo(leftMob,  { y:-20, opacity:0 }, { y:0, opacity:1, duration:D*0.9, ease:"power3.out", delay:0.06 });
        if (rightMob) gsap.fromTo(rightMob, { y: 20, opacity:0 }, { y:0, opacity:1, duration:D*0.9, ease:"power3.out", delay:0.06 });
      }
    });

    // exit — image (UNCHANGED)
    tl.to(img, {
      rotateY: dir*100, rotateX: dir*12,
      scale:0.55, y: dir*-60,
      opacity:0, filter:"blur(16px)",
      duration:D, ease:"power2.in"
    }, 0)
    // exit — bg text (UNCHANGED)
    .to(bgTxt, { opacity:0, scale:0.94, duration:D*0.6, ease:"power2.in" }, 0)
    // exit — desktop panels (UNCHANGED)
    .to(left  || {}, { x: dir*80,  opacity:0, duration:D*0.7, ease:"power2.in" }, 0)
    .to(right || {}, { x: dir*-80, opacity:0, duration:D*0.7, ease:"power2.in" }, 0)
    // exit — mobile panels (NEW)
    .to(leftMob  || {}, { y:-16, opacity:0, duration:D*0.6, ease:"power2.in" }, 0)
    .to(rightMob || {}, { y: 16, opacity:0, duration:D*0.6, ease:"power2.in" }, 0);
  }, [startFloat]);

  // ── ScrollTrigger — UNCHANGED
  useEffect(() => {
    if (progressRef.current)
      progressRef.current.style.width = `${(1/N)*100}%`;

    const ctx = gsap.context(() => {
      ScrollTrigger.create({
        trigger: wrapRef.current,
        start: "top top",
        end: "bottom bottom",
        onUpdate: (self) => {
          const next = Math.round(self.progress * (N-1));
          const dir  = next > curIdx.current ? 1 : -1;
          if (next !== curIdx.current) transitionTo(next, dir);
        }
      });
    }, wrapRef);

    startFloat();
    return () => ctx.revert();
  }, [transitionTo, startFloat]);

  // ── keyboard — UNCHANGED
  useEffect(() => {
    const h = (e) => {
      if (e.key==="ArrowDown"||e.key==="ArrowRight") {
        const next = Math.min(N-1, curIdx.current+1);
        transitionTo(next, 1);
        scrollToIdx(next);
      }
      if (e.key==="ArrowUp"||e.key==="ArrowLeft") {
        const next = Math.max(0, curIdx.current-1);
        transitionTo(next, -1);
        scrollToIdx(next);
      }
    };
    window.addEventListener("keydown", h);
    return () => window.removeEventListener("keydown", h);
  }, [transitionTo]);

  const scrollToIdx = (i) => {
    if (!wrapRef.current) return;
    const pct    = i/(N-1);
    const totalH = wrapRef.current.scrollHeight - window.innerHeight;
    window.scrollTo({ top: wrapRef.current.offsetTop + pct*totalH, behavior:"smooth" });
  };

  const goTo = useCallback((i) => {
    const dir = i > curIdx.current ? 1 : -1;
    transitionTo(i, dir);
    scrollToIdx(i);
  }, [transitionTo]); // eslint-disable-line

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs.sendForm(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      formRef.current,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    ).then(()=>{ alert("Sent!"); setModal(false); }, ()=>alert("Failed. Try again."));
  };

  return (
    <div style={{ fontFamily:"'Syne',sans-serif" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700&family=Syne:wght@400;500;600;700;800&display=swap');

        /* ── UNCHANGED: image 3D + blend ── */
        #caax-img {
          transform-style: preserve-3d;
          will-change: transform, opacity, filter;
          mix-blend-mode: normal;
          filter: drop-shadow(0 50px 80px rgba(0,0,0,0.8)) drop-shadow(0 0 40px rgba(6,204,188,0.3)) brightness(1.02);
          transition: filter 0.7s ease;
        }

        /* ── UNCHANGED: giant bg text ── */
        #caax-bg-text {
          position: absolute;
          inset: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          pointer-events: none;
          user-select: none;
        }
        .caax-bg-word {
          font-family: 'Syne', sans-serif;
          font-weight: 800;
          line-height: 0.88;
          letter-spacing: -0.03em;
          white-space: nowrap;
        }

        /* ── UNCHANGED ── */
        #caax-prog { transition: width .5s ease, background .8s ease; }
        .caax-dot  { border-radius:2px; transition: height .4s ease, background .4s ease; display:block; cursor:pointer; }

        @keyframes mq  { from{transform:translateX(0)} to{transform:translateX(-50%)} }
        @keyframes hu  { from{opacity:0;transform:translateY(28px)} to{opacity:1;transform:translateY(0)} }
        @keyframes mIn { from{opacity:0;transform:scale(.95) translateY(12px)} to{opacity:1;transform:scale(1) translateY(0)} }
        @keyframes spin{ from{transform:rotate(0deg)} to{transform:rotate(360deg)} }

        .mq   { display:flex; width:max-content; animation:mq 32s linear infinite; }
        .hu1  { animation:hu .9s cubic-bezier(.22,1,.36,1) both  .1s;  opacity:0; }
        .hu2  { animation:hu .9s cubic-bezier(.22,1,.36,1) both  .25s; opacity:0; }
        .hu3  { animation:hu .9s cubic-bezier(.22,1,.36,1) both  .4s;  opacity:0; }
        .hu4  { animation:hu .9s cubic-bezier(.22,1,.36,1) both  .55s; opacity:0; }
        .m-in { animation:mIn .35s cubic-bezier(.22,1,.36,1) both; }

        /* ── UNCHANGED desktop panels ── */
        #caax-left, #caax-right { will-change: transform, opacity; }

        /* ── NEW: mobile panels also need will-change for GSAP ── */
        #caax-left-m, #caax-right-m { will-change: transform, opacity; }
      `}</style>

      {/* ── HERO — only padding adjusted for mobile, content UNCHANGED ── */}
      <section className="relative w-full flex flex-col items-center justify-center text-center px-6 py-20 md:py-36">
        <p className="hu1 text-xs font-bold tracking-[.35em] uppercase mb-5" style={{color:"#06CCBC"}}>
          CAAX 
        </p>
        <h1 className="hu2 font-black text-white leading-none mb-6"
          style={{fontSize:"clamp(2.6rem,9vw,8rem)",fontFamily:"'Playfair Display',serif",letterSpacing:"-.04em"}}>
          Grow Smarter.<br /><span style={GT}>Live Greener.</span>
        </h1>
        <p className="hu3 max-w-md mx-auto text-base md:text-lg leading-relaxed mb-10" style={{color:"rgba(255,255,255,.7)", fontWeight:400}}>
          Seven precision-engineered hydroponics products. Scroll to explore each one.
        </p>
        <div className="hu4 flex flex-wrap justify-center gap-2 md:gap-3">
          {[["90%","Less Water"],["300+","Plants"],["7","Products"],["IoT","Connected"]].map(([n,l],i)=>(
            <div key={i} className="flex items-baseline gap-2 px-4 py-2 md:px-5 md:py-2.5 rounded-full"
              style={{border:"1px solid rgba(255,255,255,.08)"}}>
              <span className="text-lg md:text-xl font-black" style={GT}>{n}</span>
              <span className="text-xs text-gray-300 font-medium">{l}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ── MARQUEE — UNCHANGED ── */}
      <div className="overflow-hidden border-y py-3.5" style={{borderColor:"rgba(255,255,255,.05)"}}>
        <div className="mq">
          {[...Array(2)].map((_,o)=>
            ["4 sq.ft Device","Planter","Stem Kit","2 sq.ft Indoor","Wall Garden","DWC Outdoor Kit","Polyhouse","IoT Farming","Soil-Free","Sustainable"].map((w,i)=>(
              <span key={`${o}-${i}`} className="text-xs font-bold tracking-[.3em] uppercase mx-8"
                style={{color:i%4===0?"#06CCBC":"rgba(255,255,255,.07)"}}>
                {w} ·
              </span>
            ))
          )}
        </div>
      </div>

      {/* ── SCROLL WRAPPER — UNCHANGED ── */}
      <div ref={wrapRef} style={{height:`${N*100}vh`, position:"relative"}}>

        {/* STICKY PANEL — UNCHANGED */}
        <div style={{position:"sticky", top:0, height:"100vh", overflow:"hidden"}}>

          {/* Ambient glow — UNCHANGED */}
          <div className="absolute inset-0 pointer-events-none transition-all duration-1000"
            style={{background:`radial-gradient(ellipse 70% 80% at 50% 50%, rgba(${p.rgb},.07) 0%, transparent 65%)`}} />

          {/* Top progress — UNCHANGED */}
          <div className="absolute top-0 left-0 right-0 z-30" style={{height:"2px",background:"rgba(255,255,255,.04)"}}>
            <div id="caax-prog" ref={progressRef}
              style={{height:"100%",width:`${(1/N)*100}%`,background:`linear-gradient(90deg,rgba(${p.rgb},.9),rgba(${p.rgb},.3))`}} />
          </div>

          {/* Giant bg text — UNCHANGED */}
          <div id="caax-bg-text" ref={bgTextRef}>
            {p.bgWords.map((word, wi) => (
              <div key={wi} className="caax-bg-word transition-colors duration-700"
                style={{
                  fontSize: "clamp(4rem, 14vw, 13rem)",
                  color: `rgba(${p.rgb}, ${wi===0 ? 0.18 : 0.11})`,
                }}>
                {word}
              </div>
            ))}
          </div>

          {/* ── SHARED FLOATING IMAGE ── sits in absolute center, visible on ALL screens,
               GSAP animates this one element — zero duplication, works desktop + mobile ── */}
          <div className="absolute inset-0 z-10 flex items-center justify-center pointer-events-none"
            style={{perspective:"1000px", perspectiveOrigin:"50% 50%"}}>
            <div className="flex flex-col items-center">
              <img
                id="caax-img"
                ref={imgRef}
                src={p.image}
                alt={p.nameSub}
                draggable={false}
                style={{
                  /* Desktop: uses vw sizing; mobile: uses smaller vw via clamp */
                  width: "clamp(160px, 24vw, 420px)",
                  height: "auto",
                  display: "block",
                  mixBlendMode: "normal",
                  filter: `drop-shadow(0 50px 80px rgba(0,0,0,0.8)) drop-shadow(0 0 40px rgba(${p.rgb},0.3)) brightness(1.02)`,
                  transform: "perspective(1000px) rotateY(0deg) rotateX(0deg)",
                  transition: "filter 0.7s ease",
                  pointerEvents: "none",
                }}
              />
              {/* Glow puddle */}
              <div className="rounded-full blur-3xl -mt-8 pointer-events-none transition-all duration-700"
                style={{width:"55%", height:"30px", background:`rgba(${p.rgb},.25)`}} />
            </div>
          </div>

          {/* ── DESKTOP 3-col layout — UNCHANGED ── */}
          <div className="hidden lg:flex relative z-10 h-full items-center justify-center px-4 md:px-12">
            <div className="w-full max-w-screen-xl grid items-center"
              style={{gridTemplateColumns:"1fr auto 1fr", gap:"clamp(1rem,4vw,5rem)"}}>

              {/* LEFT — UNCHANGED */}
              <div id="caax-left" ref={leftRef} className="flex flex-col space-y-5">
                <div className="flex items-end gap-3 select-none">
                  <span className="font-black leading-none transition-colors duration-700"
                    style={{fontSize:"6.5rem",color:`rgba(${p.rgb},.12)`,fontFamily:"'Playfair Display',serif",lineHeight:1}}>
                    {p.num}
                  </span>
                  <div className="mb-2">
                    <span className="block text-xs font-black tracking-[.28em] uppercase transition-colors duration-500"
                      style={{color:p.accent}}>{p.tag}</span>
                    <div className="mt-1.5 h-0.5 w-8 rounded-full transition-all duration-500"
                      style={{background:p.accent}} />
                  </div>
                </div>
                <h2 className="font-black text-white leading-none"
                  style={{fontSize:"clamp(1.8rem,2.8vw,2.8rem)",fontFamily:"'Playfair Display',serif",letterSpacing:"-.03em"}}>
                  {p.nameSub}
                </h2>
                <p className="text-xs font-black tracking-[.25em] uppercase transition-colors duration-500"
                  style={{color:p.accent, opacity:.9}}>{p.tagline}</p>
                <p className="text-gray-200 leading-relaxed" style={{maxWidth:"290px", fontSize:"14px", lineHeight:"1.7", fontWeight:400}}>{p.desc}</p>
                <button onClick={()=>setModal(true)}
                  className="self-start px-7 py-3 rounded-full text-sm font-black tracking-wide transition-all hover:scale-105 hover:brightness-110 pointer-events-auto"
                  style={{background:p.accent,color:"#000",boxShadow:`0 0 28px rgba(${p.rgb},.45)`,transition:"background .5s,box-shadow .5s"}}>
                  Inquire Now →
                </button>
              </div>

              {/* CENTER spacer — image is absolutely positioned above */}
              <div style={{width:"clamp(240px,28vw,420px)"}} />

              {/* RIGHT — UNCHANGED */}
              <div id="caax-right" ref={rightRef} className="flex flex-col space-y-6">
                <div>
                  <p className="text-xs font-black tracking-[.32em] uppercase mb-3" style={{color:"rgba(255,255,255,.35)"}}>Specifications</p>
                  <div className="grid grid-cols-2 gap-2">
                    {p.specs.map((s,i)=>(
                      <div key={i} className="p-3.5 rounded-2xl transition-all duration-700"
                        style={{border:`1px solid rgba(${p.rgb},.18)`,background:`rgba(${p.rgb},.06)`}}>
                        <div className="text-xs mb-1 tracking-widest uppercase font-semibold" style={{color:"rgba(255,255,255,.38)"}}>{s.l}</div>
                        <div className="font-black text-sm transition-colors duration-500" style={{color:p.accent}}>{s.v}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div>
                  <p className="text-xs font-black tracking-[.32em] uppercase mb-3" style={{color:"rgba(255,255,255,.35)"}}>Features</p>
                  <div className="space-y-2.5">
                    {p.feats.map((f,i)=>(
                      <div key={i} className="flex items-center gap-3">
                        <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-500"
                          style={{background:`rgba(${p.rgb},.14)`,border:`1px solid rgba(${p.rgb},.4)`}}>
                          <svg width="9" height="7" viewBox="0 0 9 7" fill="none">
                            <path d="M1 3.5L3.2 5.5L8 1" stroke={p.accent} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </div>
                        <span className="text-sm font-medium" style={{color:"rgba(255,255,255,.82)"}}>{f}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="h-px transition-all duration-700"
                  style={{background:`linear-gradient(90deg,rgba(${p.rgb},.5),transparent)`}} />
                <div className="font-black text-right select-none leading-none"
                  style={{fontSize:"4.5rem",color:`rgba(${p.rgb},.07)`,fontFamily:"'Playfair Display',serif",transition:"color .5s"}}>
                  {p.num}
                </div>
              </div>
            </div>
          </div>

          {/* ── MOBILE layout — vertical stack, image shown via absolute layer above ── */}
          <div className="lg:hidden relative z-10 h-full flex flex-col justify-between py-12 px-5">

            {/* TOP: tag pill + product name + tagline */}
            <div id="caax-left-m" ref={leftMobRef} className="text-center space-y-1">
              <div className="flex items-center justify-center gap-2 mb-1">
                <div className="h-px w-5 flex-shrink-0" style={{background:p.accent}} />
                <span className="text-xs font-black tracking-[.28em] uppercase transition-colors duration-500"
                  style={{color:p.accent, opacity:.95}}>{p.tag}</span>
                <div className="h-px w-5 flex-shrink-0" style={{background:p.accent}} />
              </div>
              <h2 className="font-black text-white leading-tight"
                style={{fontSize:"clamp(1.5rem,6.5vw,2.2rem)",fontFamily:"'Playfair Display',serif",letterSpacing:"-.03em"}}>
                {p.nameSub}
              </h2>
              <p className="text-xs font-bold tracking-[.18em] uppercase"
                style={{color:p.accent, opacity:.7}}>{p.tagline}</p>
            </div>

            {/* SPACER — the image floats here via the absolute layer */}
            <div className="flex-1" />

            {/* BOTTOM: specs 2×2 grid + CTA */}
            <div id="caax-right-m" ref={rightMobRef} className="space-y-3">
              <div className="grid grid-cols-2 gap-2">
                {p.specs.map((s,i)=>(
                  <div key={i} className="p-3 rounded-xl transition-all duration-700"
                    style={{border:`1px solid rgba(${p.rgb},.18)`,background:`rgba(${p.rgb},.06)`}}>
                    <div className="mb-0.5 tracking-widest uppercase font-semibold"
                      style={{fontSize:"9px", color:"rgba(255,255,255,.4)"}}>{s.l}</div>
                    <div className="font-black text-xs transition-colors duration-500"
                      style={{color:p.accent}}>{s.v}</div>
                  </div>
                ))}
              </div>
              <button onClick={()=>setModal(true)}
                className="w-full py-3.5 rounded-full text-sm font-black tracking-wide transition-all active:scale-95 pointer-events-auto"
                style={{background:p.accent,color:"#000",boxShadow:`0 0 20px rgba(${p.rgb},.4)`,transition:"background .5s,box-shadow .5s"}}>
                Inquire Now →
              </button>
            </div>

          </div>
          {/* END MOBILE LAYOUT */}

          {/* ── Dot nav — desktop only ── */}
          <div className="hidden lg:flex absolute left-4 md:left-7 top-1/2 -translate-y-1/2 z-20 flex-col gap-2.5">
            {PRODUCTS.map((pr,i)=>(
              <button key={i}
                ref={el=>dotRefs.current[i]=el}
                className="caax-dot"
                onClick={()=>goTo(i)}
                title={pr.nameSub}
                style={{
                  width:"3px",
                  height: i===0 ? "32px":"10px",
                  background: i===0 ? PRODUCTS[0].accent : "rgba(255,255,255,.2)",
                }} />
            ))}
          </div>

          {/* ── Counter — desktop only ── */}
          <div className="hidden lg:block absolute bottom-6 right-6 z-20">
            <span className="text-sm font-black transition-colors duration-500" style={{color:p.accent}}>{p.num}</span>
            <span className="text-sm font-bold text-gray-700"> / {String(N).padStart(2,"0")}</span>
          </div>

          {/* ── Arrows — both mobile & desktop, counter shown inline on mobile ── */}
          <div className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 flex items-center gap-3">
            <button onClick={()=>goTo(Math.max(0,idx-1))} disabled={idx===0}
              className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110 active:scale-95"
              style={{border:`1px solid rgba(${p.rgb},${idx===0 ? .1 : .4})`,color:idx===0?"rgba(255,255,255,.15)":p.accent}}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M15 18l-6-6 6-6"/></svg>
            </button>
            {/* counter visible on mobile between arrows */}
            <span className="text-xs font-black lg:hidden" style={{color:p.accent}}>
              {p.num}<span className="text-gray-700 font-bold"> / {String(N).padStart(2,"0")}</span>
            </span>
            {/* scroll hint on desktop first product */}
            {idx===0 && <span className="text-xs text-gray-600 tracking-widest uppercase animate-bounce select-none hidden lg:inline">scroll ↓</span>}
            <button onClick={()=>goTo(Math.min(N-1,idx+1))} disabled={idx===N-1}
              className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110 active:scale-95"
              style={{border:`1px solid rgba(${p.rgb},${idx===N-1 ? .1 : .4})`,color:idx===N-1?"rgba(255,255,255,.15)":p.accent}}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M9 18l6-6-6-6"/></svg>
            </button>
          </div>

          {/* ── Tagline watermark — desktop only, UNCHANGED ── */}
          <div className="absolute bottom-16 left-1/2 -translate-x-1/2 z-10 text-center pointer-events-none select-none hidden lg:block">
            <p className="text-xs font-bold tracking-[.3em] uppercase transition-colors duration-500"
              style={{color:`rgba(${p.rgb},.5)`, letterSpacing:".3em"}}>
              {p.tagline}
            </p>
          </div>

        </div>
        {/* /sticky */}
      </div>
      {/* /scroll wrapper */}

      {/* ── WHY CAAX — UNCHANGED ── */}
      <section className="w-full max-w-6xl mx-auto px-6 py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <p className="text-xs font-black tracking-[.35em] uppercase mb-4" style={{color:"#06CCBC", opacity:.9}}>Why CAAX</p>
            <h2 className="font-black text-white leading-none mb-6"
              style={{fontSize:"clamp(2.2rem,5vw,4rem)",fontFamily:"'Playfair Display',serif",letterSpacing:"-.03em"}}>
              Grown with <span style={GT}>Science,</span><br />Not Soil.
            </h2>
            <p className="leading-relaxed mb-8 max-w-md" style={{color:"rgba(255,255,255,.65)", fontSize:"15px", lineHeight:"1.8"}}>
              Every CAAX product is built around one principle — do more with less.
              Less water, less energy, less space. More food, more control, more freedom.
            </p>
            <button onClick={()=>setModal(true)}
              className="px-8 py-4 rounded-full text-white font-bold text-sm tracking-wide transition-all hover:scale-105"
              style={{...GB,boxShadow:"0 4px 30px rgba(18,99,175,.35)"}}>
              Get Your CAAX Today
            </button>
          </div>
          <div className="space-y-1">
            {[
              {n:"90%", t:"Less Water",    d:"Closed-loop hydroponic systems with near-zero water waste."},
              {n:"0.03",t:"KWh / Month",   d:"Grow fresh greens for less power than a phone charger."},
              {n:"IoT", t:"Connected",     d:"Real-time monitoring, automated nutrients, mobile app."},
              {n:"7×",  t:"Product Range", d:"From 6-plant Stem Kits to 500+ sq.ft Polyhouses."},
            ].map((item,i)=>(
              <div key={i} className="flex items-start gap-6 p-5 rounded-2xl cursor-default transition-all hover:bg-white/[.03]"
                style={{borderBottom:i<3?"1px solid rgba(255,255,255,.05)":"none"}}>
                <div className="font-black flex-shrink-0 w-14 text-right text-2xl"
                  style={{fontFamily:"'Playfair Display',serif",...GT}}>{item.n}</div>
                <div>
                  <div className="font-black text-white mb-1 text-sm tracking-wide">{item.t}</div>
                  <div className="text-sm leading-relaxed" style={{color:"rgba(255,255,255,.55)"}}>{item.d}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA — UNCHANGED ── */}
      <section className="w-full max-w-6xl mx-auto px-6 pb-24">
        <div className="relative overflow-hidden rounded-3xl p-10 md:p-16 text-center"
          style={{border:"1px solid rgba(255,255,255,.06)"}}>
          <div className="absolute -top-20 -right-20 w-56 h-56 rounded-full pointer-events-none"
            style={{border:"1px solid rgba(6,204,188,.07)",animation:"spin 25s linear infinite"}} />
          <div className="absolute -bottom-12 -left-12 w-40 h-40 rounded-full pointer-events-none"
            style={{border:"1px solid rgba(18,99,175,.07)",animation:"spin 18s linear infinite reverse"}} />
          <div className="relative z-10">
            <p className="text-xs font-black tracking-[.35em] uppercase mb-4" style={{color:"#06CCBC", opacity:.9}}>Start Growing Today</p>
            <h2 className="font-black text-white leading-none mb-6"
              style={{fontSize:"clamp(2rem,5vw,4rem)",fontFamily:"'Playfair Display',serif",letterSpacing:"-.03em"}}>
              Your farm. Your food.<br /><span style={GT}>Your CAAX.</span>
            </h2>
            <p className="max-w-lg mx-auto mb-8 leading-relaxed" style={{color:"rgba(255,255,255,.6)", fontSize:"15px", lineHeight:"1.8"}}>
              From first-time growers to commercial producers — there's a CAAX product built exactly for you.
            </p>
            <button onClick={()=>setModal(true)}
              className="px-10 md:px-12 py-4 md:py-5 rounded-full text-white font-bold text-base transition-all hover:scale-105"
              style={{...GB,boxShadow:"0 8px 40px rgba(18,99,175,.4)"}}>
              Connect With Us →
            </button>
          </div>
        </div>
      </section>

      {/* ── MODAL — UNCHANGED ── */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-xl">
          <div className="m-in w-full max-w-md rounded-3xl overflow-hidden shadow-2xl"
            style={{border:"1px solid rgba(255,255,255,.08)",background:"rgba(6,10,20,.98)"}}>
            <div className="px-6 md:px-8 pt-7 md:pt-8 pb-5 border-b" style={{borderColor:"rgba(255,255,255,.06)"}}>
              <div className="flex items-start justify-between">
                <div>
                  <div className="text-xs font-black tracking-[.25em] uppercase mb-2" style={{color:"#06CCBC"}}>Get in Touch</div>
                  <h2 className="font-black text-white"
                    style={{fontSize:"1.5rem",fontFamily:"'Playfair Display',serif",letterSpacing:"-.03em"}}>Connect With Us</h2>
                </div>
                <button onClick={()=>setModal(false)}
                  className="w-9 h-9 rounded-full flex items-center justify-center text-gray-500 hover:text-white transition-colors mt-1"
                  style={{border:"1px solid rgba(255,255,255,.1)"}}>
                  <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                  </svg>
                </button>
              </div>
            </div>
            <div className="px-6 md:px-8 py-5 md:py-6">
              <form ref={formRef} onSubmit={handleSubmit} className="space-y-4">
                {[
                  {label:"Name",  name:"name",   type:"text",  ph:"Your full name"},
                  {label:"Phone", name:"number", type:"text",  ph:"Your phone number"},
                  {label:"Email", name:"email",  type:"email", ph:"your@email.com"},
                ].map(field=>(
                  <div key={field.name}>
                    <label className="block text-xs font-bold tracking-widest uppercase text-gray-600 mb-2">{field.label}</label>
                    <input type={field.type} name={field.name} placeholder={field.ph} required
                      className="w-full px-4 py-3 rounded-xl text-white placeholder-gray-700 text-sm focus:outline-none"
                      style={{background:"rgba(255,255,255,.04)",border:"1px solid rgba(255,255,255,.08)"}} />
                  </div>
                ))}
                <div>
                  <label className="block text-xs font-bold tracking-widest uppercase text-gray-600 mb-2">Message</label>
                  <textarea name="message" required placeholder="Which CAAX product interests you?"
                    className="w-full px-4 py-3 rounded-xl text-white placeholder-gray-700 text-sm focus:outline-none resize-none"
                    style={{background:"rgba(255,255,255,.04)",border:"1px solid rgba(255,255,255,.08)",minHeight:"85px"}} />
                </div>
                <div className="flex gap-3 pt-1">
                  <button type="button" onClick={()=>setModal(false)}
                    className="flex-1 py-3 rounded-xl text-sm font-semibold text-gray-500 hover:text-gray-300 transition-colors"
                    style={{border:"1px solid rgba(255,255,255,.08)"}}>Cancel</button>
                  <button type="submit"
                    className="flex-1 py-3 rounded-xl text-white font-bold text-sm hover:opacity-90 transition-opacity"
                    style={GB}>Send Message</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}